import { Component, OnInit } from "@angular/core";
import { ProfileService } from "src/app/dashboard/services/profile.service";
import { ProfileInfo } from "src/app/dashboard/model/interface.model";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import Swal from "sweetalert2";

@Component({
  selector: "app-account-verification",
  templateUrl: "./account-verification.component.html",
  styleUrls: ["./account-verification.component.css"],
})
export class AccountVerificationComponent implements OnInit {
  user: ProfileInfo = null;
  numberVerificationForm: FormGroup;

  tokenSent: boolean = false;
  verifyMobileNumberLoading: boolean = false;

  constructor(private profile: ProfileService) {}
  ngOnInit() {
    this.numberVerificationForm = new FormGroup({
      number: new FormControl(null, [Validators.required]),
      token: new FormControl(null, [Validators.required]),
    });

    this.getUserInfo();
  }

  getUserInfo() {
    this.profile.userInfoBasic().subscribe((response) => {
      this.user = response.data;
      this.numberVerificationForm.patchValue({
        number: this.user.number,
      });
    });
  }

  requestVerificationToken() {
    let formData: { number: string } = {
      number: this.numberVerificationForm.value.number,
    };
    this.profile.getMobileVerificationToken(formData).subscribe(
      (response) => {
        if (response.request_status) {
          this.tokenSent = true;
          Swal.fire("verification token sent", "", "success");
        } else {
          Swal.fire("", response.error_message, "warning");
        }
      },
      (error) => {
        Swal.fire("", error.error.error_message, "error");
      }
    );
  }

  verifyMobileNumber() {
    this.verifyMobileNumberLoading = true;

    let formData: { number: string; token: string } = {
      number: this.numberVerificationForm.value.number,
      token: this.numberVerificationForm.value.token,
    };

    this.profile.verifyMobileNumber(formData).subscribe(
      (response) => {
        this.verifyMobileNumberLoading = false;
        if (response.request_status) {
          this.tokenSent = false;
          this.getUserInfo();
          Swal.fire("Mobile number verified", "", "success");
        } else {
          Swal.fire("", response.error_message, "warning");
        }
      },
      (error) => {
        this.verifyMobileNumberLoading = false;
        Swal.fire("", error.error.error_message, "error");
      }
    );
  }
}
